import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a4fdb94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-confim-layout" }
const _hoisted_2 = { class: "m-confirm-container" }
const _hoisted_3 = {
  key: 0,
  class: "confim-title"
}
const _hoisted_4 = {
  key: 1,
  class: "confim-desc"
}
const _hoisted_5 = {
  key: 2,
  class: "confim-desc"
}
const _hoisted_6 = {
  key: 3,
  class: "confim-desc-arr"
}
const _hoisted_7 = { class: "m-button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.confirmInfo.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.confirmInfo.title), 1))
        : _createCommentVNode("", true),
      ($props.confirmInfo.subTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.confirmInfo.subTitle), 1))
        : _createCommentVNode("", true),
      ($props.confirmInfo.detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.confirmInfo.detail), 1))
        : _createCommentVNode("", true),
      ($props.confirmInfo.detailArr)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($props.confirmInfo.detailArr), 1))
        : _createCommentVNode("", true),
      ($props.confirmInfo.titleArr)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList($props.confirmInfo.titleArr, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "confim-desc-arr",
              key: 'titleArr' + index
            }, _toDisplayString(item), 1))
          }), 128))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        ($props.confirmInfo.cancelText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "u-confirm-button u-cancel",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.doClose && $setup.doClose(...args)))
            }, _toDisplayString($props.confirmInfo.cancelText), 1))
          : _createCommentVNode("", true),
        ($props.confirmInfo.confirmText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "u-confirm-button u-confirm",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.doConfirm && $setup.doConfirm(...args)))
            }, _toDisplayString($props.confirmInfo.confirmText), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512)), [
    [_vShow, $props.visible]
  ])
}